import { formatPrice } from './payments';
export function getNorwegianSurchargeLabel(surchargeType, lowerCase = false) {
    const label = {
        evening: 'Kveldstillegg',
        weekend: 'Helgetillegg',
        holiday: 'Helligdagstillegg',
    }[surchargeType];
    return lowerCase ? label.toLowerCase() : label;
}
export const getNorwegianSurchargeInfoText = (type, price) => `*Inkl. ${getNorwegianSurchargeLabel(type, true)} på ${formatPrice(price)},-`;
export function getServiceHasSurcharge(service) {
    if (!service)
        return false;
    const weekendSurcharge = service?.weekendSurcharge ?? 0;
    const eveningSurcharge = service?.eveningSurcharge ?? 0;
    if (service.price <= 0)
        return false;
    return weekendSurcharge > 0 || eveningSurcharge > 0;
}
